import { InventoryLocations } from './Inventory';
import { ProductCatalogBE } from './Products';
import { User } from './User';

type BinNum = {
  id: string;
  binNo: number;
  quantity: number;
  inventoryLocation: InventoryLocations;
};
type StoreProduct = {
  productCatalog?: ProductCatalogBE;
  binNums?: BinNum[];
  unbinned?: number;
};

export type OrderItem = {
  id: string;
  count: number;
  skuNo: string;
  pickedCount: number;
  salesOrderId: string;
  storeProduct?: StoreProduct;
};

export type OrdersTypeFilter = 'BOPIS' | 'eCommerce';

export type OrderStatus =
  | 'Pending'
  | 'In progress'
  | 'Ready for pickup'
  | 'Ready for shipping'
  | 'Picked up'
  | 'Shipped'
  | 'Complete';

export type SaleOrdersSearchBy = 'customerName' | 'id';

export type SaleOrder = {
  id: string;
  customerName: string;
  storeNo: number;
  assignedAssociate?: User;
  dueDate: string;
  items: OrderItem[];
  orderStatus: OrderStatus;
  itemCount?: number;
  orderType?: OrdersTypeFilter;
};

export const orderStatusOptions: {
  label: OrderStatus;
  value: OrderStatus;
  id: string;
}[] = [
  {
    label: 'Pending',
    value: 'Pending',
    id: 'pending',
  },
  {
    label: 'In progress',
    value: 'In progress',
    id: 'inProgress',
  },
  {
    label: 'Ready for pickup',
    value: 'Ready for pickup',
    id: 'readyForPickup',
  },
  {
    label: 'Ready for shipping',
    value: 'Ready for shipping',
    id: 'readyForShipping',
  },
  {
    label: 'Picked up',
    value: 'Picked up',
    id: 'pickedUp',
  },
  {
    label: 'Shipped',
    value: 'Shipped',
    id: 'shipped',
  },
  {
    label: 'Complete',
    value: 'Complete',
    id: 'complete',
  },
];

export const statusClassMap: Record<OrderStatus, string> = {
  Pending: 'gray',
  'In progress': 'blue',
  'Ready for pickup': 'green',
  'Ready for shipping': 'green',
  'Picked up': 'dark-green',
  Shipped: 'dark-green',
  Complete: 'dark-green',
};
